'use strict';

module.exports = function(app) {
    var notifications = require('./counter-change')(app);

    $(document).off('submit.ajax-form');
    $(document).on('submit.ajax-form', '.ajax-form', function (e) {
        e.preventDefault();

        var form          = $(this);
        var formContainer = form.parent();

        $.ajax({
            type    : 'POST',
            url     : form.attr('action'),
            data    : form.serialize(),
            dataType: 'json',
            encode  : true
        }).complete(function (data) {
            formContainer.html(data.responseText);

            var form = $(data.responseText);
            if (form.hasClass('js-notifications-form')) {
                notifications.notificationCountRefresh(form);
            }
        });
    });

    return app;
};
